/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ResponseStatusEnum = "Accepted" | "Declined" | "NeedsAction" | "NotApplicable" | "Tentative" | "%future added value";
export type SuggestedAutopilotSettingsV3MovementType = "Day" | "Week" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type UrnTypeEnum = "Email" | "Integration" | "Org" | "Phone" | "User" | "%future added value";
export type AutopilotSuggestionEnableMeeting_referencedEvents = ReadonlyArray<{
    readonly title: string | null;
    readonly startTime: {
        readonly millis: number;
    };
    readonly endTime: {
        readonly millis: number;
    };
    readonly eventKey: {
        readonly externalEventId: string;
    };
    readonly attendees: ReadonlyArray<{
        readonly displayName: string | null;
        readonly profileId: string | null;
        readonly optional: boolean | null;
        readonly organizer: boolean | null;
        readonly resource: boolean | null;
        readonly responseStatus: ResponseStatusEnum | null;
        readonly urnType: UrnTypeEnum | null;
        readonly urnValue: string;
    }>;
    readonly suggestedAutopilotSettingsResponseV3: {
        readonly __typename: "SuggestedAutopilotSettingsResponseV3";
        readonly intersectionOfAttendeesMeetingHours: {
            readonly minSlot: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            };
            readonly maxSlot: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            };
        } | null;
        readonly calendarIdToMeetingHours: ReadonlyArray<{
            readonly calendarId: string;
            readonly dayOffsetTimeSlotRanges: ReadonlyArray<{
                readonly minSlot: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                };
                readonly maxSlot: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                };
            }>;
        }>;
        readonly suggestedAutopilotSettings: {
            readonly isRoomFlexible: boolean;
            readonly movementType: SuggestedAutopilotSettingsV3MovementType;
            readonly allowedEndTime: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            } | null;
            readonly allowedStartTime: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            } | null;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly moveRangeInLocalTimeV3: {
        readonly __typename: "MoveRangeInLocalTimeV3";
        readonly allowedStartTimeInclusive: {
            readonly dayOffset: number;
            readonly timeSlot: TimeSlot;
        } | null;
        readonly allowedEndTimeInclusive: {
            readonly dayOffset: number;
            readonly timeSlot: TimeSlot;
        } | null;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "AutopilotSuggestionEnableMeeting_referencedEvents";
}>;
export type AutopilotSuggestionEnableMeeting_referencedEvents$data = AutopilotSuggestionEnableMeeting_referencedEvents;
export type AutopilotSuggestionEnableMeeting_referencedEvents$key = ReadonlyArray<{
    readonly " $data"?: AutopilotSuggestionEnableMeeting_referencedEvents$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionEnableMeeting_referencedEvents">;
}>;



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v3 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v2 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v2 /*: any*/),
            "storageKey": null
        } as any
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "AutopilotSuggestionEnableMeeting_referencedEvents",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "startTime",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "endTime",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventKey",
                "kind": "LinkedField",
                "name": "eventKey",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalEventId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Attendee",
                "kind": "LinkedField",
                "name": "attendees",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profileId",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "optional",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "organizer",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resource",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "responseStatus",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urnType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urnValue",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "suggestedAutopilotSettingsResponseV3",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlotRange",
                                "kind": "LinkedField",
                                "name": "intersectionOfAttendeesMeetingHours",
                                "plural": false,
                                "selections": (v3 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                                "kind": "LinkedField",
                                "name": "calendarIdToMeetingHours",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "calendarId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlotRange",
                                        "kind": "LinkedField",
                                        "name": "dayOffsetTimeSlotRanges",
                                        "plural": true,
                                        "selections": (v3 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedAutopilotSettingsV3",
                                "kind": "LinkedField",
                                "name": "suggestedAutopilotSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRoomFlexible",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "movementType",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlot",
                                        "kind": "LinkedField",
                                        "name": "allowedEndTime",
                                        "plural": false,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlot",
                                        "kind": "LinkedField",
                                        "name": "allowedStartTime",
                                        "plural": false,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "SuggestedAutopilotSettingsResponseV3",
                        "abstractKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "moveRangeInLocalTimeV3",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedStartTimeInclusive",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedEndTimeInclusive",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "type": "MoveRangeInLocalTimeV3",
                        "abstractKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "Event",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'c5f8d1aaa116dae5ab8ce2331901dc06';
export default node;
